import { render, staticRenderFns } from "./RetencionUpdate.vue?vue&type=template&id=451f843a&scoped=true"
import script from "./RetencionUpdate.vue?vue&type=script&lang=js"
export * from "./RetencionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f843a",
  null
  
)

export default component.exports